export const environment = {
  type: "local",
  restrictionFreePlans: true,
  production: true,
  hmr: false,
  mock: true,
  apiUrl: "https://dashboard.serversmtp.com/api",
  newApiUrl: "https://gateway.dev.serversmtp.com/billing-revamp-dev/api/v2",
  loginUrl:
    "https://gateway.dev.serversmtp.com/billing-revamp-dev/login?url=https://billing-revamp.dev.dashboard.serversmtp.com/dashboard",
  logoutUrl: "https://gateway.dev.serversmtp.com/billing-revamp-dev/logout",
  signupUrl:
    "https://keycloak.dev.serversmtp.com/realms/turbosmtp-realm/protocol/openid-connect/registrations?client_id=turbosmtp-client&response_type=code&scope=openid&redirect_uri=https://billing-revamp.panel.dev.serversmtp.com",
  cookieDomain: ".serversmtp.com",
  matomoSiteId: null,
  googleClientId:
    "849537850523-k1b03ud5mgnstp37mfv3qaa1b9m9u8ft.apps.googleusercontent.com",
  gtmId: "GTM-K47QNTMC" as string | null,
  gtmEnvParams: null as string | null,
};
